<template>
    <div class="grid">
    <div class="col-12">
        <Card id="toolbar">
            <template #title>
                <Toolbar>
                    <template #right>
                        <div class="p-card-title" style="margin-top:10px;">
                            <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="downloadPrint()" />
                            <Button v-if="this.$IS_PRINT_DOCUMENT == 'TRUE'" label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="exportToPDF" />
                            <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                        </div>
                    </template>
                </Toolbar>
            </template>
        </Card>
        <div class="surface-0">
            <div id="apps" class="center">
                <table class="table"  ref="document" style="font-family:'Times New Roman', Times, serif;font-size:13px;" v-if="dataDocument">
                    <thead>
                         <tr>
                            <td colspan="2" style="width:30%;" class="no-border"> <img :src="imgdocumentation" style="float:left;" width="120" height="40" v-if="imgdocumentation"> </td>
                            <!-- <td colspan="5" style="width:70%;" class="no-border">  <img src="/assets/layout/images/wilmar-logo.png"  style="float:right;" width="120" height="40"/></td> -->
                        </tr>
                        <tr>
                            <td colspan="7" style="text-align:center;" class="no-border">
                                <span style="font-weight:bold; font-size:20px; text-decoration: underline;">BERITA ACARA KETERLAMBATAN KERJA</span>
                                <br/>
                                <span style="font-size:15px;">No. Document: {{dataDocument.Doc_No}}</span>
                            </td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="7" class="no-border"> 
                                <!-- <div id="content">
                                <div id="pageFooter">Page </div>
                                multi-page content here...
                              </div> -->
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr  style="height:20px;text-align:left;">
                            <td colspan="7" class="no-border"><p>Bersama ini kami menerangkan bahwa pada,</p></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">Hari/Tanggal</td>
                            <td colspan="5" v-if="dataDocument" class="no-border">: {{dataDocument!=null ? this.$formatDateNameDay(dataDocument.Hari_Tanggal):""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">Kontraktor</td>
                            <td colspan="5" v-if="dataDocument" class="no-border">: {{dataDocument!=null ? dataDocument.contractor:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">Pekerjaan</td>
                            <td colspan="5" v-if="dataDocument" class="no-border">: {{dataDocument !=null ? dataDocument.Deskripsi_Pekerjaan:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">No. SPO</td>
                            <td colspan="5" v-if="dataDocument" class="no-border">: {{dataDocument.No_SPO!=null ? dataDocument.No_SPO: " - "}}</td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="7" class="no-border"> </td>
                        </tr>
                        <tr>
                            <td colspan="3">Tanggal Selesai SPO/SPK</td>
                            <td colspan="2" v-if="dataDocument">{{this.$formatDate(dataDocument.Tanggal_Selesai)}}</td>
                            <td colspan="2" style="width:30%;"></td>
                        </tr>
                        <tr>
                            <td colspan="3">Tanggal Final Inspeksi QC</td>
                            <td colspan="2" v-if="dataDocument">{{this.$formatDate(dataDocument.Tanggal_Final)}}</td>
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <td colspan="3">Terhitung Jumlah Hari Keterlambatan</td>
                            <td colspan="2"  v-if="dataDocument">{{dataDocument.Jumlah_Hari_Keterlambatan}} Hari Kalender</td>
                            <td colspan="2">Kecuali hari nasional</td>
                        </tr>

                        <tr style="height:15px;">
                            <td colspan="7" class="no-border"> </td>
                        </tr>

                        <tr style="text-align:center;font-weight:bold;">
                            <td style="width:10%;">No.</td>
                            <td colspan="2">Keterangan Keterlambatan</td>
                            <td colspan="2">Tanggal Mulai</td>
                            <td>Tanggal Selesai</td>
                            <td>Hari</td>
                        </tr>
                        <!-- :class="{'pagebreak' : arrindex.includes(i+1)}" -->
                        <tr v-for="(item, i) in dataDocument.Details" :key="item.Id" style="text-align:center;" :class="{'pagebreak' : arrindex.includes(i+1)}">
                            <td>{{i+1}}</td>
                            <td colspan="2" style="text-align:left;">{{item.Description}}</td>
                            <td colspan="2">{{this.$formatDate(item.Tanggal_Mulai)}}</td>
                            <td>{{this.$formatDate(item.Tanggal_Selesai)}}</td>
                            <td>{{item.Hari}}</td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="4" class="crossed"></td>
                            <td colspan="2"><span style="float:right;">Jumlah Hari</span></td>
                            <td v-if="dataDocument" style="text-align:center;">{{dataDocument.Details.reduce((sum,obj)=>sum + obj['Hari'],0)}}</td>
                        </tr>
                    
                    <!-- :class="{'tfoot' : arrindex.length > 18}" -->
                        <tr style="height:15px;text-align:center;">
                            <td colspan="4">Disepakati Oleh, </td>
                            <td colspan="3">Disetujui Oleh,</td>
                        </tr>
                        <tr style="height:70px;text-align:center;">
                           
                            <td colspan="2">
                                <p class="fontsign" v-if="dataDocument.Appr_Name1">
                                    {{ dataDocument.Appr_Name1 }}
                                    <br/>
                                    {{this.$formatDateTime1(dataDocument.ApprDate1)}}
                                </p>
                            </td>
                            <td colspan="2">
                                <p class="fontsign" v-if="dataDocument.Appr_Name2">
                                    {{ dataDocument.Appr_Name2 }}
                                    <br/>
                                    {{this.$formatDateTime1(dataDocument.ApprDate2)}}
                                </p>
                                
                            </td>
                            <td colspan="3">
                                <p class="fontsign" v-if="dataDocument.Appr_Name3">
                                    {{ dataDocument.Appr_Name3 }}
                                    <br/>
                                    {{this.$formatDateTime1(dataDocument.ApprDate3)}}
                                </p>
                            </td>
                        </tr>
                        <!-- <tr style="text-align:left;">
                            <td colspan="2" v-if="dataDocument" style="color:rgb(174, 169, 169);border-bottom: none;border-top:none;">{{dataDocument.Username_Site_Manager}}</td>
                            <td colspan="2" v-if="dataDocument" style="color:rgb(174, 169, 169);border-bottom: none;border-top:none;">{{dataDocument.Username_PM_PIC_Contractor}}</td>
                            <td colspan="3" v-if="dataDocument" style="color:rgb(174, 169, 169);border-bottom: none;border-top:none;">{{dataDocument.Username_PM_PIC_Company}}</td>
                        </tr> -->
                        <tr style="text-align:left;">
                            <td colspan="2" style="border-bottom: none;border-top:none;">{{ dataDocument.Appr_As1 }}</td>
                            <td colspan="2" style="border-bottom: none;border-top:none;">{{ dataDocument.Appr_As2 }}</td>
                            <td colspan="3" style="border-bottom: none;border-top:none;">{{ dataDocument.Appr_As3 }}</td>
                        </tr>
                        <tr style="text-align:left;">
                            <td colspan="2" v-if="dataDocument" style="color:rgb(174, 169, 169);border-top:none;">{{dataDocument.comp1}}</td>
                            <td colspan="2" v-if="dataDocument" style="color:rgb(174, 169, 169);border-top:none;">{{dataDocument.comp2}}</td>
                            <td colspan="3" v-if="dataDocument" style="color:rgb(174, 169, 169);border-top:none;">{{dataDocument.comp3}}</td>
                        </tr>
                        <tr style="text-align:center;">
                            <td colspan="4" style="border-top: none;" v-if="dataDocument">Result : {{dataDocument.Result}}</td>
                            <td colspan="3" style="border-top: none;"></td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="7" class="no-border"></td>
                        </tr>
                        <tr style="text-align:center;">
                            <td colspan="7" class="no-border">Demikian berita acara ini kami buat sebenar-benarnya, agar digunakan sebagaimana mestinya.</td>
                        </tr>
                        <tr style="height:15px;">
                    
                        </tr>
                        <tr style="text-align:center;">
                            <td colspan="7" class="no-border">Diketahui Oleh,</td>
                        </tr>
                        <tr style="height:40px;text-align:center;">
                            <td colspan="7" class="no-border"> 
                                 <p class="fontsign" v-if="dataDocument.Appr_Name4">
                                    {{ dataDocument.Appr_Name4 }}
                                    <br/>
                                    {{this.$formatDateTime1(dataDocument.ApprDate4)}}
                                 </p>
                            </td>
                        </tr>
                        <tr style="text-align:center;">
                            <td colspan="7" v-if="dataDocument" class="no-border">
                                <hr>
                            </td>
                        </tr>
                    
                        <tr style="text-align:center;">
                            <td colspan="7" class="no-border">{{ dataDocument.Appr_As4 }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2" class="no-border tdfoot">
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT || dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || dataDocument.Status == this.$APPROVAL_STATUS.REVISED"/>
                            </td>
                            <td class="no-border tdfoot" colspan="5">
                                <VueQrcode :value="valueLink" style="width:85px;float:right;margin-left: 210px;"></VueQrcode>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="7" v-if="dataDocument.is_aproved" class="no-border">
                                <p style="font-size:10px;">
                                    <b>
                                        {{ 
                                              this.signBy(dataDocument)
                                        
                                        }}

                                    </b>
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 20px;" v-if="dataDocument.is_aproved">
                            <td style="border: none;"></td>
                        </tr>
                    </tfoot>
                
                </table>
            </div> 
        </div>
</div>
</div>

</template>
<script>
import html2pdf from 'html2pdf.js'
export default{
data(){
    return {

        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        type :this.$TypeDocument.BA_IK_WITH_SPO,
        compCode : "",
        dataDocument:null,
        imgdocumentation : "",
        companydetail : null,
        valueLink :this.$store.getters.getUrlApp + this.$route.fullPath,
        arrindex : [],
        signby : this.$DOCUMENTFOOTER.APPROVED_GENERATED +" (Document Print by " + this.$store.getters.getFullname + " at " + this.$formatDateTime2(new Date()) + ")"
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; 
        return this.signby;
    },  
    downloadPrint(){
        this.$emit('block-ui');
            var self = this;
                const link = this.valueLink;
                //var qr = document.getElementById('qr').src;
                //const [mimeType, base64Data] = dataURL.split(';base64,');
                this.$axios.get(this.$API_URL + "BaDelay/" + "downloadprint", {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG,
                params : {
                    id : this.$route.query.id,
                    linqr : link,
                    company : this.dataDocument.company,
                    contractor : this.dataDocument.contractor,
                    signby : this.signby,
                }  
                })
                .then((response) => {
                    //const url = window.URL.createObjectURL(new Blob([response.data]));
                    let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];

                    const blob = new Blob([response.data], { type: 'application/pdf' });

                    // Create an object URL from the Blob
                    const url = URL.createObjectURL(blob);
                    // Set the iframe src attribute to the object URL
                    window.open(url, '_blank');
                    //this.$refs.pdfPreview.src = url;
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', fileName);
                    // document.body.appendChild(link);
                    // link.click();
                    self.$emit('unblock-ui');
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    self.$emit('unblock-ui');
                    //self.showAssignModal = false;
                });
    },
    backToIndex(){
        if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
        else 
            this.$router.push({ path: "/BaDelay/Index" });
    },

    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.round(scrollHeight / window.outerHeight);
        
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";
            
            if(i != 0){
                pageNumberDiv.style.top = "calc((279mm - (0.5px + " +(i+1)+ "px)) * " + (i+1)+ " - 30px)";
            }else{
                pageNumberDiv.style.top = "calc((279mm - 0.5px) * " + (i+1)+ " - 30px)";
            }

            pageNumberDiv.style.right = 0;
            //pageNumberDiv.style.height = "12px";
            //pageNumberDiv.style.marginBlockStart = "10px"
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },

    exportToPDF() {
        html2pdf(this.$refs.document, {
            margin: 10,
            filename: 'myfile.pdf',
            image: { type: 'jpeg', quality: 1},
            html2canvas: { scale: 4},
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },

        })
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "BaDelay/getDataDoc/"+ this.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.imgdocumentation = data.imgdocumentation;
                self.companydetail = data.companydetail;
                self.dataDocument.Details.forEach((a,i) => {
                    self.arrindex.push(22 + (43 * i))
                });
                self.$emit('unblock-ui');
            
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 6000 });
                    self.$emit('unblock-ui');
            });
        },
    },
    computed:{
    },   
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.getData();
    },
}
</script>
<style>

@page {
    size: A4 portrait !important;
  
    @top-left {
      content: "should be shown on the top-left";
      font-size: 15px;
      color: #979797;
      text-align: left;
    }

    @top-right{
        content: "should be shown on the top-left";
        font-size: 15px;
        color: #979797;
        text-align: left;
    }

    @bottom-right{
        content: "should be shown on the top-left";
        font-size: 15px;
        color: #979797;
        text-align: left;
    }
}

@media print {
    body {
        float: none;
        margin-left: 0;
        margin-top: 0;
        counter-reset: section;
    }
    
    #content {
        display: table;
    }
    
    #pageFooter {
        display: table-footer-group;
    }
    
    #pageFooter:after {
        counter-increment: page;
        content: counter(page);
    }
   
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 10px;
        margin: 0;
     }
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}
#apps{
    width: 80%;
}

</style>
<style scoped>
@media print {
    tfoot {
      position: fixed;
      bottom: 0;
      width: 100%;
    }

    .tdfoot{
        width: 100%;
    }

    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    body{
      width: 100%;
      margin: 0 auto;
    }

    #apps{
        width: 100%;
        margin-top: -5px;
    }
    .pagebreak{
        page-break-after: always;
    }
    .tfoot{
        width: 97.20%;
        position: fixed;
        bottom: 0;
        left: 10px;
        right: 0;
    }
}
.table .no-border {
    border: none;
  }
.crossed
{
    background: linear-gradient(to bottom right, transparent 49.5%, black 49.5%, black 50.5%, transparent 50.5%) !important;
}

.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}
.table td, .table th {
    border: 1px solid black;
}

.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    padding: 0.3px;
    border-bottom: 1.8px solid black;
    margin : 0 auto;
    width:110px;
   }



#toolbar{
    max-height: 90px;
}

.title{
    font-size: 20px;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  .fontsign{
    font-family: 'Monotype Corsiva'
  }
</style>
